import React from "react";
import "../../styles/nobookings.css";

const NoBookings = () => {
  return (
    <div className="nobookings">
      <p>Désolé, il n'y a pas de réservations pour le moment :-(</p>
    </div>
  );
};

export default NoBookings;
